import { Layout, Input, Select, Space, Table, TablePaginationConfig, Card, Button } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { API } from '../../api';
import { PagedResultState } from '../../common/CommonResult';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { ForeignCustomers } from '../../lib/ForeignCustomer';
import { CustomsPackageImport } from './CustomsPackageImport';
import CustomerSelect from '../../lib/CustomerSelect';
import { render } from '@testing-library/react';
import dayjs from 'dayjs';

const { Search } = Input;

const ForeignOrderPackage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchState, changeSearchState] = useState<any>({});
  const [customer, setCustomer] = useState<any>(null);
  const [state, setState] = useState<PagedResultState<any>>({ loading: false, result: {} });
  const [query, setQuery] = useState('');
  const [showImport, changeShowImport] = useState(false);

  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      const params = queryString.parse(location.search);
      setQuery((params.packageNumber as string) || '');
      fetchData(location.search);
    } else {
      navigate(`/foreign/package?page=1&size=10`);
    }
  }, [location.search]);
  const changeSearch = useCallback(
    (val: any) => {
      const res = { ...queryString.parse(location.search), ...val };
      navigate(`?${queryString.stringify(res)}`);
    },
    [navigate, location]
  );
  const fetchData = useCallback(
    async (search: string) => {
      setState({ ...state, loading: true });
      try {
        const response: any = await API.get({ apiVersion: 'api' })(
          `/foreign/package/list${search}`
        );
        setState({ loading: false, result: response.result });
      } catch (e) {
        console.log(e);
        setState({ loading: false, error: true, result: {} });
      }
    },
    [state]
  );

  const onSearch = () => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      packageNumber: query,
      page: 1,
    };
    navigate(`/foreign/package?${queryString.stringify(search)}`);
  };

  const handleTableChange = (pagination: TablePaginationConfig) => {
    const params = queryString.parse(location.search);

    const search = {
      ...params,
      page: pagination.current || 1,
      size: pagination.pageSize || 10,
    };
    navigate(`/foreign/package?${queryString.stringify(search)}`);
  };

  const columns = [
    {
      title: 'Богц №',
      dataIndex: 'packageNumber',
      render: (row: any, data: any) => <Link to={`/foreign/package/detail/${data.no}`}>{row}</Link>,
      key: 'packageNumber',
    },
    {
      title: 'Харилцагч',
      dataIndex: 'customer',

      render: (data: any) => data?.name,
      key: 'customerName',
    },
    {
      title: 'Жин',
      dataIndex: 'weight',

      render: (data: any) => data,
      key: 'weight',
    },
    {
      title: 'Илгээмж',
      dataIndex: 'shipmentCount',
      key: 'shipmentCount',
    },
    {
      title: 'Огноо',
      dataIndex: 'createdAt',
      render: (data: any) => <span>{dayjs(data).format('YYYY-MM-DD HH:mm')}</span>,
      key: 'createdAt',
    },
    {
      title: 'Төлөв',
      render: (data: any) => {
        return <span>{data.customs !== null ? 'Гааль' : 'Үүссэн'}</span>;
      },
      key: 'status',
    },
  ];

  return (
    <Layout.Content style={{ margin: '24px 16px 0' }}>
      <Card
        title="Гадаад захиалгын богц"
        extra={<Button onClick={() => changeShowImport(true)}>open</Button>}
      >
        <Space wrap style={{ marginBottom: 15 }}>
          <Search
            placeholder="Богцны дугаар"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onSearch={onSearch}
            style={{ width: 200 }}
          />
          {/* <CustomerSelect
            showSearch
            defaultQuery={{ type: 'CN' }}
            allowClear
            value={searchState.customer}
            onChange={(e) => changeSearchState({ ...searchState, customer: e, page: 1 })}
          />
          <Select style={{ width: 250 }} placeholder="Харилцагч" allowClear>
            {Object.keys(ForeignCustomers).map((key) => {
              const typedKey = key as keyof typeof ForeignCustomers;
              return <Select.Option value={key}>{ForeignCustomers[typedKey]}</Select.Option>;
            })}
          </Select> */}
          <Select style={{ width: 250 }} placeholder="Төлөв" allowClear>
            <Select.Option value="sample1">Үүссэн</Select.Option>
            <Select.Option value="sample3">Хүлээн авсан</Select.Option>
          </Select>
          <CustomerSelect
            showSearch
            defaultQuery={{ type: 'CN' }}
            allowClear
            value={customer}
            onChange={(value) => {
              console.log(value);
              setCustomer(value);
              changeSearch({ customerNo: value });
            }}
          />
        </Space>
        <Table
          pagination={{
            pageSize: state.result.size,
            current: state.result.page,
            total: state.result.total,
          }}
          onChange={handleTableChange}
          loading={state.loading}
          dataSource={state.result?.data}
          columns={columns}
          rowKey="no"
        />
      </Card>
      <CustomsPackageImport
        open={showImport}
        onClose={() => changeShowImport(false)}
        onSuccess={() => changeShowImport(false)}
      />
    </Layout.Content>
  );
};

export default ForeignOrderPackage;
